import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Tabs } from 'antd';

import isEmpty from 'lodash/isEmpty';
import { Row, Col } from 'reactstrap';
import SearchInputGroup from './subComponents/SearchInputGroup';
import SearchBadge from './subComponents/SearchBadge';
import TooltipTab from './subComponents/ToolTipTab';
import './SolicitationsSearchBar.scss';
import msgs from '../../config/messages';
import { isFeatureEnabled } from '../../config/featureFlags';
import { SubsContext } from '../Billsby/SubscriptionInfo';

// Whitelist of CAGE codes allowed to see ACE feature
const ACE_ENABLED_CAGE_CODES = ['1UH05', '4BFG8', '81LA2'];

const TabPane = Tabs.TabPane;

export default class SolicitationsSearchBar extends React.PureComponent {
  static propTypes = {
    meta: PropTypes.object,
    onSearchButtonClick: PropTypes.func.isRequired,
    onSearchInputKeyDown: PropTypes.func.isRequired,
    onSearchInputChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    bidMatchingSettings: PropTypes.object.isRequired,
    searchText: PropTypes.string,
    tabChanged: PropTypes.func.isRequired,
    selectedTab: PropTypes.string.isRequired,
    statusAggs: PropTypes.object.isRequired,
    folderAggs: PropTypes.object.isRequired,
    organizationsCage: PropTypes.string.isRequired,
    auth: PropTypes.shape({
      role: PropTypes.string,
    }),
  };

  static defaultProps = {
    meta: {},
    searchText: '',
    auth: { role: 'COMMON_USER' },
  };

  static _generateBidMatchingSettings = bidMatchingSettings => {
    const keys = Object.keys(bidMatchingSettings);
    let value;
    const badges = keys.map((bmKey) => {
      value = bidMatchingSettings[bmKey];
      return (
        <SearchBadge
          key={`bid-matching-badge-${bmKey}`}
          {...{ value, name: bmKey }}
        />
      );
    });

    /*
    * Handle empty badges array case.
    * Note: the expectation is that we will never be missing
    * bid-matching settings unless they are loading.
    */
    if (!badges || isEmpty(badges)) {
      return '';
    }

    return (
      <Fragment>
        {badges}
        {/* <LinkContainer to={bidMatchingRoute}>
          <NFButton className="nf-button--link">
            {msgs.SolicitationsSearchBar.editBidMatching}
          </NFButton>
        </LinkContainer> */}
      </Fragment>
    );
  };

  render() {
    const {
      meta,
      onSearchButtonClick,
      onSearchInputKeyDown,
      onSearchInputChange,
      isLoading,
      searchText,
      bidMatchingSettings,
      tabChanged,
      selectedTab,
      statusAggs,
      folderAggs,
      auth,
    } = this.props;
    const aggObj = {};
    const hits = meta.hits || 0;
    if (folderAggs) {
      folderAggs.map(obj => {
        const key = obj.key;
        const value = obj.docCount;
        aggObj[key] = value;
        return '';
      });
      if (statusAggs) {
        statusAggs.map(obj => {
          const key = obj.key;
          const value = obj.docCount;
          aggObj[key] = value;
          return '';
        });
      }
    }
    return (
      <SubsContext.Consumer>
        {() => (
          <div className="nf-solicitations-search-bar">
            <Row>
              <Col sm={12} xl={4} className="nf-solicitations-search-bar__col--label">
                {/* <!-- LABEL --> */}
                <div className="nf-solicitations-search-bar__label">
                  {!isLoading && (
                    <span>{msgs.SolicitationsSearchBar.hitsCount(hits)}</span>
                  )}
                </div>
              </Col>
              <Col sm={12} xl={4}>
                {/* <!-- SEARCH INPUT GROUP --> */}
                <div className="nf-solicitation-search-field">
                  <SearchInputGroup
                    {...{
                      onSearchButtonClick,
                      onSearchInputKeyDown,
                      searchText,
                      onSearchInputChange,
                    }}
                  />
                </div>
              </Col>
              <Col sm={12} xl={4} >
                <div className="nf-solicitations-bid-settings">
                  {/* <!-- BID-MATCHING SETTINGS --> */}
                  {selectedTab === 'matched' && auth.role !== 'GOVERNMENT_USER' &&
                    SolicitationsSearchBar._generateBidMatchingSettings(
                      bidMatchingSettings,
                    )}
                </div>
              </Col>
            </Row>
            <div style={{ display: 'flex', paddingTop: '6px' }}>
              <div style={{ height: '40px' }}>
                <Tabs
                  activeKey={selectedTab}
                  type="card"
                  className="tab-wrapper"
                  onChange={key => tabChanged(key)}
                >
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          statusAggs && aggObj
                            ? `Open (${aggObj.open || 0})`
                            : 'Open'
                        }
                        tooltip={msgs.ToolTips.open}
                      />
                    }
                    key="open"
                  />
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          statusAggs && aggObj
                            ? `Closed (${aggObj.closed || 0})`
                            : 'Closed'
                        }
                        tooltip={msgs.ToolTips.closed}
                      />
                    }
                    key="closed"
                  />
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          statusAggs && aggObj
                            ? `Awarded (${aggObj.awarded || 0})`
                            : 'Awarded'
                        }
                        tooltip={msgs.ToolTips.awarded}
                      />
                    }
                    key="awarded"
                  />
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          statusAggs && aggObj
                            ? `Cancelled (${aggObj.cancelled || 0})`
                            : 'Cancelled'
                        }
                        tooltip={msgs.ToolTips.cancelled}
                      />
                    }
                    key="cancelled"
                  />
                  {auth.role !== 'GOVERNMENT_USER' && (
                    <TabPane
                      tab={
                        <TooltipTab
                          title={
                            statusAggs && aggObj
                              ? `Matched (${aggObj.matched || 0})`
                              : 'Matched'
                          }
                          tooltip={msgs.ToolTips.matches}
                        />
                      }
                      key="matched"
                    />
                  )}

                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          folderAggs && aggObj
                            ? `Flagged (${aggObj.flagged || 0})`
                            : 'Flagged'
                        }
                        tooltip={msgs.ToolTips.flagged}
                      />
                    }
                    key="flagged"
                  />
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          folderAggs && aggObj
                            ? `To Be Quoted (${aggObj.tbq || 0})`
                            : 'To Be Quoted'
                        }
                        tooltip={msgs.ToolTips.tqb}
                      />
                    }
                    key="tbq"
                  />
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          folderAggs && aggObj
                            ? `In Process (${aggObj.inprocess || 0})`
                            : 'In Process'
                        }
                        tooltip={msgs.ToolTips.ip}
                      />
                    }
                    key="inprocess"
                  />

                  {/* <TabPane tab="Pending Request" key="pendingrequests" /> */}
                  <TabPane
                    tab={
                      <TooltipTab
                        title={
                          folderAggs && aggObj
                            ? `Archived (${aggObj.archived || 0})`
                            : 'Archived'
                        }
                        tooltip={msgs.ToolTips.archived}
                      />
                    }
                    key="archived"
                  />
                  {auth.role !== 'GOVERNMENT_USER' && isFeatureEnabled('ENABLE_ACE') && ACE_ENABLED_CAGE_CODES.includes(this.props.organizationsCage) && (
                    <TabPane
                      tab={
                        <TooltipTab
                          title={
                            folderAggs && aggObj
                              ? `Sent to ACE (${aggObj.ace || 0})`
                              : 'Sent to ACE'
                          }
                          tooltip={msgs.ToolTips.ace}
                        />
                      }
                      key="ace"
                    />
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        )}
      </SubsContext.Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/SolicitationsSearchBar.jsx